import RenderFuturePotentialDelayDrivers from 'components/widgets/FinishDateFuturePotentialDelayDrivers/components/FinishDateFuturePotentialDelayDrivers';
import React from 'react';

export const FinishDateFuturePotentialDelayDriversWrapper = ({
    projectId,
    contractId,
    latestVersionId,
    compareVersionId,
    globalFilterData,
}) => {
    if (!globalFilterData?.milestoneFragnet) {
        return null;
    }

    return (
        <RenderFuturePotentialDelayDrivers
            projectId={projectId}
            contractId={contractId}
            latestVersionId={latestVersionId}
            compareVersionId={compareVersionId}
            globalFilterData={globalFilterData}
        />
    );
};
